module.exports = __webpack_public_path__ + "img/article-4.0a696b03.jpg";